import React, { useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import Select from 'react-select';
import { useAuth } from '../context/AuthContext';
import { DICT } from '../utils/dictionary';
import { API_BASE, getAuthHeaders } from '../utils/api';

// Mock Data para popular o Select no modo Demonstração
const MOCK_USERS = [
  { nome: "Maycon Bruno", cargo: DICT.CARGOS_ETAPAS[0] || "ESPECIALISTA" },
  { nome: "Renata Oliveira", cargo: DICT.CARGOS_ETAPAS[1] || "GERENTE" },
  { nome: "Lucas S.", cargo: DICT.CARGOS_ETAPAS[2] || "ANALISTA" },
  { nome: "Mariana Costa", cargo: DICT.CARGOS_ETAPAS[0] || "ESPECIALISTA" },
  { nome: "Pedro Silva", cargo: "REVISOR" }
];

const AddMemberModal = ({ show, onHide, onAdd }) => {
  const { token, isDemo } = useAuth(); // Importamos o isDemo
  const [usuarios, setUsuarios] = useState([]);
  const [selecionado, setSelecionado] = useState(null);

  useEffect(() => {
    if (!show) return;

    // Intercepta a chamada no modo Demo
    if (isDemo) {
      const options = MOCK_USERS.map(u => ({
        value: u.nome.toUpperCase(),
        label: `${u.nome.toUpperCase()} (${u.cargo.toUpperCase()})`,
        cargo: u.cargo.toUpperCase()
      })).sort((a, b) => a.label.localeCompare(b.label));
      
      setUsuarios(options);
      return;
    }

    // Comportamento de Produção (Real)
    fetch(`${API_BASE}/users/`, {
      headers: getAuthHeaders(token)
    })
      .then(res => res.json())
      .then(data => {
        if (!Array.isArray(data)) return;

        const options = data.map(u => ({
          value: u.nome.toUpperCase(),
          label: `${u.nome.toUpperCase()} (${u.cargo.toUpperCase()})`,
          cargo: u.cargo.toUpperCase()
        }));

        options.sort((a, b) => a.label.localeCompare(b.label));
        setUsuarios(options);
      })
      .catch(err => console.error('Erro ao carregar usuários:', err));
      
  }, [show, token, isDemo]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selecionado) return;
    await onAdd({
      nome: selecionado.value,
      cargo: selecionado.cargo
    });
    setSelecionado(null);
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Atribuir ao {DICT.CONTENT_SING}</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group>
            <Form.Label className="small text-muted fw-bold">Selecionar Colaborador</Form.Label>
            <Select
              options={usuarios}
              value={selecionado}
              onChange={setSelecionado}
              placeholder="Buscar nome do membro..."
              isSearchable
              noOptionsMessage={() => "Nenhum colaborador encontrado"}
              styles={{
                control: (base) => ({
                  ...base,
                  borderColor: '#dee2e6',
                  boxShadow: 'none',
                  '&:hover': { borderColor: 'var(--brand-primary)' }
                })
              }}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button variant="outline-secondary" onClick={onHide}>Cancelar</Button>
          <Button type="submit" variant="primary" disabled={!selecionado} style={{ backgroundColor: 'var(--brand-primary)', borderColor: 'var(--brand-primary)' }}>
            Adicionar
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddMemberModal;